import dayjs, { Dayjs } from "dayjs"
import type { Immutable } from "../utils/immer"
import { produce } from "../utils/immer"
import { create } from "zustand"

type DashboardFiltersState = {
  dates: Dayjs[]
  filterByTimePeriod: string
  environment: string
  onPeriodSelected: string
  filterDates: Dayjs[]
}

type DashboardFiltersActions = {
  setDates: (dates: Dayjs[]) => void
  setFilterByTimePeriod: (timePeriod: string) => void
  setEnvironment: (environment: string) => void
  setOnPeriodSelected: (period: string) => void
  setFilterDates: (dates: Dayjs[]) => void
}

export type DashboardFiltersStore = Immutable<DashboardFiltersState & DashboardFiltersActions>

export const useDashboardFiltersStore = create<DashboardFiltersStore>(setStore => ({
  dates: [],
  filterByTimePeriod: "Minute",
  environment: "All environments",
  onPeriodSelected: "Past 1 Hour",
  filterDates: [dayjs().add(-1, "hour"), dayjs()],
  setDates: dates => {
    console.log("DashboardFiltersStore - setDates called with:", 
      dates.map(d => d.format('YYYY-MM-DD HH:mm:ss')));
    setStore(
      produce(state => {
        state.dates = dates
      })
    )
  },
  setFilterByTimePeriod: timePeriod => {
    console.log("DashboardFiltersStore - setFilterByTimePeriod called with:", timePeriod);
    setStore(
      produce(state => {
        state.filterByTimePeriod = timePeriod
      })
    )
  },
  setEnvironment: environment => {
    console.log("DashboardFiltersStore - setEnvironment called with:", environment);
    setStore(
      produce(state => {
        state.environment = environment
      })
    )
  },
  setOnPeriodSelected: period => {
    console.log("DashboardFiltersStore - setOnPeriodSelected called with:", period);
    setStore(
      produce(state => {
        state.onPeriodSelected = period
      })
    )
  },
  setFilterDates: dates => {
    console.log("DashboardFiltersStore - setFilterDates called with:", 
      dates.map(d => d.format('YYYY-MM-DD HH:mm:ss')));
    setStore(
      produce(state => {
        state.filterDates = dates
      })
    )
  },
}))
